<div class="seccion-via-pago-principal" *ngIf="!loading && !isError">
  <app-boton-volver (clickVolver)="goBack()"></app-boton-volver>
  <div class="seccion-via-pago-contenido">
    <div class="seccion-cabezera">
      <h1 class="titulo">Elige tu vía de pago</h1>
      <p class="subtitulo">Selecciona cómo quieres recibir tu pensión, puede ser depósito, pago presencial, entre
        otras alternativas.</p>
    </div>

    <form class="seccion-formulario" [formGroup]="form">
      <div class="seccion-selector">
        <span class="titulo-selector">{{labelViaPago}}</span>
        <app-dropdownlist [placeholder]="labelViaPago" [options]="viaPagoOptions"
          formControlName="codigoViaPago"></app-dropdownlist>
      </div>

      <div class="seccion-selector" *ngIf="selectTiposBancos">
        <span class="titulo-selector">{{labelBanco}}</span>
        <app-dropdownlist [placeholder]="labelBanco" [options]="bancosOptions"
          formControlName="codigoInstitucionFinanciera"></app-dropdownlist>
      </div>

      <fieldset id="fieldset-tipo-cuenta" class="seccion-tipos-cuentas" *ngIf="selectTiposBancos">
        <legend id="legend-tipo-cuenta" class="titulo-tipos-cuentas">Selecciona un tipo de cuenta</legend>
        <div class="seccion-lista-cuentas" role="radiogroup" aria-labelledby="legend-tipo-cuenta">
          <ion-chip *ngFor="let item of tipoCuentas; let i = index" [outline]="item.seleccionado"
            (click)="seleccionarCuenta(item.idTipoCuenta)" (keydown.enter)="seleccionarCuenta(item.idTipoCuenta)"
            [attr.aria-checked]="!item.seleccionado" role="radio" [attr.name]="'tipo-cuenta'">
            {{ item.nameTipoCuenta }}
          </ion-chip>
        </div>
      </fieldset>

      <div *ngIf="selectTiposBancos" class="seccion-input">
        <app-input-formulario formControlName="numeroCuenta" inputId="numero-cuenta" label="Ingresa un número de cuenta"
          placeholder="Ingresa un número de cuenta" inputmode="numeric" tipo="numeric" [longitudMaxima]="18"
          [soloLectura]="isCuentaRut" [prevenirPegar]="true" [prevenirMenuContextual]="true"
          [patronValidacion]="numericPattern">
        </app-input-formulario>
      </div>

      <div *ngIf="isCheckLegal" class="info-checkLegal" id="checkLegal">
        <ion-checkbox id="checkbox-legal" slot="start" labelPlacement="end" alignment="center" justify="start"
          formControlName="checkLegal" (keydown.enter)="enterCheckLegal()">
          {{ labelCheckLegal }}
        </ion-checkbox>
      </div>

      <div *ngIf="selectTiposBancos" class="seccion-consideraciones">
        <h2 class="titulo">
          Considera que:
        </h2>
        <ul>
          <li *ngIf="isCuentaRut">
            Para la Cuenta Rut de Banco Estado, el depósito puede ser rechazado si es mayor a $4.000.000 mensuales o
            si tu saldo en la cuenta es mayor a $5.000.000.
          </li>
          <li>
            Debes ingresar una cuenta unipersonal que esté a tu nombre.
          </li>
          <li *ngIf="!isCuentaRut">
            Por seguridad, no es posible depositar tu pensión en cuentas digitales como Mach, Superdigital, Check,
            Tenpo, FAN, entre otras.
          </li>
        </ul>
      </div>

      <div class="seccion-boton">
        <button class="boton-continuar" [disabled]="isInvalidForm || isLoading" (click)="continue()">
          Continuar
          <ion-spinner name="crescent" slot="end" *ngIf="isLoading;" color="light"></ion-spinner>
        </button>
      </div>
    </form>
  </div>
</div>

<!-- SKELETON -->

<div class="seccion-via-pago-principal" *ngIf="loading && !isError">
  <div class="seccion-via-pago-contenido">
    <ion-skeleton-text animated
      style="width: 100%; height: 30px; border-radius: 12px; margin-top: 48px;"></ion-skeleton-text>

    <div class="seccion-formulario">
      <form [formGroup]="form">
        <div class="seccion-selector">
          <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 12px"></ion-skeleton-text>
        </div>

        <div class="seccion-selector">
          <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 12px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 12px"></ion-skeleton-text>
        </div>

        <div class="seccion-tipos-cuentas">
          <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 12px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 12px"></ion-skeleton-text>
        </div>

        <div class="info-checkLegal">
          <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 12px"></ion-skeleton-text>
        </div>

        <div class="seccion-boton-skeleton">
          <div class="boton-continuar">
            <ion-skeleton-text animated style="width: 100%; height: 30px; border-radius: 12px"></ion-skeleton-text>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<app-generic-error *ngIf="isError" [ops]="errorOps" [retryAttempt]="attempt" (retryEvent)="onRetryEvent()"
  (goToEvent)="onGoToEvent()">
</app-generic-error>